import { useCallback, useReducer } from 'react';
import { useLocalStorage } from 'react-use';
import { actionTypesOfNonPodiatry } from 'reducer/actionType';

export const NON_PODIATRY_KEY = 'populate_nonPodiatry';

export type WhatTreatmentsItemWithText = {
  name: string;
  text: string;
};

export type StateTypeNonPodiatry = {
  name: string;
  title: string;
  value: string[] | string;
  image?: string;
  text?: string;
  painRate?: number | string;
  options?: WhatTreatmentsItemWithText[];
};

export type ActiveTypeNonPodiatry = {
  type: string;
  name: string;
  value: string[] | string;
  image?: string;
  text?: string;
  painRate?: number | string;
  options?: WhatTreatmentsItemWithText[];
};

export const initialState: StateTypeNonPodiatry[] = [
  {
    name: actionTypesOfNonPodiatry.REASON_FOR_VISIT,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.WHICH_SIDE,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.SHOE_SIZE,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.WHERE_ON_THE_FOOT,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.DIAGNOSIS_UPLOAD_PHOTO,
    title: '',
    value: '',
  },
  {
    name: actionTypesOfNonPodiatry.HOW_LONG_EXPERIENCING_PROBLEM,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.CONSISTENTLY_OR_OFF_PROBLEM,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.HOW_DID_IT_START,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_TYPE_OF_PAIN,
    title: '',
    value: [],
    text: '',
    painRate: '0',
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_ARE_YOUR_SYMPTOMS,
    title: '',
    value: [],
    text: '',
  },
  {
    name: actionTypesOfNonPodiatry.PAIN_WORST,
    title: '',
    value: [],
    text: '',
  },
  {
    name: actionTypesOfNonPodiatry.WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.TREATMENTS_TRIED_HOME,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.SEEN_OTHER_PROVIDERS,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_TREATMENTS_RECOMMENDED_PRE_PROVIDER,
    title: '',
    value: [],
    options: [],
  },
  {
    name: actionTypesOfNonPodiatry.HOW_LONG_DID_PHYSICAL_THERAPY,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfNonPodiatry.WHAT_TREATMENTS_WERE_HELPFUL,
    title: '',
    value: [],
  },
];

const reducer = (state: any, action: ActiveTypeNonPodiatry) => {
  switch (action.type) {
    default:
      return state.map((data: StateTypeNonPodiatry) => {
        if (data.name === action.type) {
          if (action.text && action.painRate) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              text: action.text,
              painRate: action.painRate,
            };
          } if (action.painRate) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              painRate: action.painRate,
            };
          } if (action.text) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              text: action.text,
            };
          } if (action.options) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              options: action.options,
            };
          } if (action.image) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              image: action.image,
            };
          }
          return { ...data, title: action.name, value: action.value };
        } return data;
      });
  }
};

export const usePersistNonPodiatryReducer = () => {
  const [savedState, saveState] = useLocalStorage(
    NON_PODIATRY_KEY,
    initialState,
  );

  const reducerLocalStorage = useCallback(
    (state: StateTypeNonPodiatry[], action: ActiveTypeNonPodiatry) => {
      const newState = reducer(state, action);
      saveState(newState);
      return newState;
    },
    [saveState],
  );

  return useReducer(reducerLocalStorage, savedState);
};
